import React from "react";
import { Link } from "react-router-dom";
import { imageUrl } from "@/components/ImageUpload";
import { VendorTrustRow } from "@/pages/Vendors";

/**
 * Compact reusable vendor card for SEO landing pages (category / city /
 * category×city). Uses slug URLs and surfaces the trust row.
 */
export function VendorCard({ v, testid }) {
    return (
        <Link to={`/vendors/${v.vendor_slug || v.id}`} data-testid={testid || `seo-vendor-card-${v.id}`}
              className="rounded-xl border border-brand-line bg-white card-hover overflow-hidden block">
            <div className="aspect-[16/10] bg-brand-bone overflow-hidden relative">
                {v.photos && v.photos[0] ? (
                    <img src={imageUrl(v.photos[0])} alt={v.business_name} className="w-full h-full object-cover" />
                ) : (
                    <div className="w-full h-full grain" />
                )}
            </div>
            <div className="px-5 pb-5 pt-8 relative">
                <div className="absolute -top-6 left-5 h-12 w-12 rounded-xl border-2 border-white bg-brand-mint shadow flex items-center justify-center overflow-hidden">
                    {v.logo_url ? (
                        <img src={imageUrl(v.logo_url)} alt="" className="w-full h-full object-cover" />
                    ) : (
                        <span className="font-heading font-extrabold text-brand-forest">{(v.business_name || "?").slice(0, 1).toUpperCase()}</span>
                    )}
                </div>
                <div className="font-heading font-bold truncate">{v.business_name}</div>
                <div className="text-xs text-brand-mute truncate">{v.service_area || [v.home_city, v.home_state].filter(Boolean).join(", ") || "—"}</div>
                <p className="text-sm text-brand-mute mt-2 line-clamp-2">{v.description || "Professional healthcare partner ready to engage your team."}</p>
                <VendorTrustRow trust={v.trust} />
            </div>
        </Link>
    );
}

/**
 * Light review preview used on city + category landing pages — shows the
 * vendor reviewed, star count, and a short snippet. Links to the vendor.
 */
export function ReviewSnippet({ r }) {
    if (!r) return null;
    const stars = "★".repeat(r.stars) + "☆".repeat(5 - r.stars);
    return (
        <div className="rounded-xl border border-brand-line bg-white p-4" data-testid={`seo-review-${r.id}`}>
            <div className="flex items-baseline justify-between gap-3 flex-wrap">
                <div className="text-amber-500 font-bold tracking-wider text-sm">{stars}</div>
                <div className="text-[11px] text-brand-mute truncate">{r.event?.name} · {r.event?.event_date}</div>
            </div>
            {r.text && <p className="text-sm text-brand-ink/80 mt-2 line-clamp-3">{r.text}</p>}
            {r.vendor?.business_name && (
                <Link to={`/vendors/${r.vendor.vendor_slug || r.vendor.id}`} className="text-xs font-semibold text-brand-forest hover:underline mt-2 inline-block">
                    {r.vendor.business_name} →
                </Link>
            )}
        </div>
    );
}
